class NewsletterSignup extends HTMLElement {
  constructor() {
    super();
    this.observer = new MutationObserver(this.onMutations.bind(this));
    this.observer.observe(this, { childList: true, subtree: true, attributes: false });

    /** @type {HTMLInputElement | null} */
    this.input = null;

    /** @type {HTMLLabelElement | null} */
    this.label = null;

    /** @type {HTMLDivElement | null} */
    this.inputWrapper = null;

    /** @type {HTMLAnchorElement | null} */
    this.privacyLink = null;
  }

  setEventListeners() {
    if (!this.input || !this.label || !this.inputWrapper) return;

    this.inputWrapper.classList.add('input-wrapper');
    const mustBeActive = this.input.value;
    mustBeActive ? this.activate() : this.deactivate(true);

    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && this.input?.value) {
        this.checkIfInputValid();
      }
    });
    this.input.addEventListener('focus', this.removeError.bind(this));

    this.input.addEventListener('input', () => {
      this.removeError();
      this.input?.value && this.activate();
    });

    this.input.addEventListener('blur', () => {
      if (!this.input?.value) {
        this.deactivate();
        this.removeError();
      } else {
        this.checkIfInputValid();
      }
    });

    this.input.addEventListener('change', () => {
      if (!this.input?.value) {
        this.deactivate();
        this.removeError();
      } else {
        this.checkIfInputValid();
      }
    });
  }

  setError() {
    this.input?.classList.add('input-wrapper__field--error');
    this.closest('[data-input-wrapper-container]')?.classList.add('input-wrapper-container--error');
  }

  removeError() {
    this.input?.classList.remove('input-wrapper__field--error');
    this.closest('[data-input-wrapper-container]')?.classList.remove('input-wrapper-container--error');
  }

  checkIfInputValid() {
    this.input?.value && this.input.matches(':invalid') ? this.setError() : this.removeError();
  }

  activate() {
    this.inputWrapper?.classList.add('input-wrapper--filled');
    this.inputWrapper?.classList.remove('input-wrapper--empty');
  }

  deactivate(isFirstRender = false) {
    this.inputWrapper?.classList.remove('input-wrapper--filled');
    !isFirstRender && this.inputWrapper?.classList.add('input-wrapper--empty');
  }

  /**
   * @param {MutationRecord[]} mutations
   */
  onMutations(mutations) {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement) {
          this.inputWrapper = this.inputWrapper || node.querySelector('div[data-testid="form-row"]');
          if (this.inputWrapper) {
            this.input = this.input || this.inputWrapper.querySelector('input');
            this.label = this.label || this.inputWrapper.querySelector('label');
            this.privacyLink = this.privacyLink || this.inputWrapper.nextSibling?.querySelector('a');
            if (this.privacyLink) {
              this.privacyLink.href = window.theme.routes.privacy_policy_page_url;
              this.privacyLink.setAttribute('target', '_blank');
            }
          }
          if (this.input && this.label && this.privacyLink) {
            this.observer.disconnect();
            this.setEventListeners();
          }
        }
      });
    });
  }
}

customElements.define('newsletter-signup', NewsletterSignup);
